import React, { useEffect, useState } from "react";
import "./HeroSection.css";
import heroCard from "../hero-card.png"; 

const HeroSection = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const newParticles = Array.from({ length: 20 }).map((_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      delay: `${Math.random() * 2}s`,
      duration: `${3 + Math.random() * 2}s`,
    }));
    setParticles(newParticles);
  }, []);

  return (
    <section className="hero-section">
      <div className="particle-container">
        {particles.map((p) => (
          <div
            key={p.id}
            className="particle"
            style={{
              left: p.left,
              top: p.top,
              animationDelay: p.delay,
              animationDuration: p.duration,
            }}
          />
        ))}
      </div>

      <div className="hero-container">
        <div className="hero-grid">
          {/* Left Content */}
          <div className="hero-content animate-fade-in-left">
            <div className="hero-badge">
              <span className="badge-text">
                ⚡ Secure & Professional Payments
              </span>
            </div>

            <h1 className="hero-title">
              <span className="text-orange">Swipe your</span>
              <br />
              <span className="text-white"> CREDIT CARD</span>
              <br />
              <span className="text-orange">@1.79%</span>
            </h1>

            <p className="hero-description">
              Instant liquidity for <strong>Education bills</strong>, <strong>Travel</strong>, 
              <strong> Insurance</strong>, and specialized <strong>Marine & Ocean Pay</strong>. 
              Secure processing across Chennai.
            </p>

            <div className="hero-buttons">
              <a href="tel:9884135738" className="btn btn-primary">
              Swipe for
  📞 Call 6385417845
              </a>
              <a href="tel:6385417845" className="btn btn-outline">
              Payment and swipe for
 📞 Call 9884135738 
              </a>
            </div>
          </div>

          {/* Right Image */}
          <div className="hero-image-container animate-fade-in-right">
            <div className="floating-wrapper">
              <div className="hero-glow" />
              <img 
                src={heroCard} 
                alt="Premium credit card payment services" 
                className="hero-card-img" 
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;